const COOKIE_NAME = "ka_consent";
const MAX_AGE_DAYS = 180;

function readCookie(name) {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name, value, days) {
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

export function getConsent() {
  const raw = readCookie(COOKIE_NAME);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setConsent(analytics) {
  writeCookie(COOKIE_NAME, JSON.stringify({ analytics, decidedAt: new Date().toISOString() }), MAX_AGE_DAYS);
}

export function hasAnalyticsConsent() {
  const consent = getConsent();
  return Boolean(consent && consent.analytics);
}
